import { Spinner } from '@/components';
import { STATUS_MESSAGES } from '@/constants';
import React from 'react';

/**
 * FullPageLoader is a reusable component that displays a full-page loading state with a spinner,
 * a heading, and a message. It is designed to be used in scenarios where the user needs to wait
 * for a process to complete, such as during authentication, data loading, or processing tasks.
 */
export const FullPageLoader: React.FC<{ heading?: string; message?: string }> = ({
  heading = STATUS_MESSAGES.LOADING,
  message,
}) => {
  return (
    <div className="flex h-screen max-h-[80vh] items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-4 text-center">
        <Spinner size={48} />
        <h2 className="typography-section-title mb-2 text-semantic-text-primary">{heading}</h2>
        {message && <p className="typography-body text-semantic-text-secondary">{message}</p>}
      </div>
    </div>
  );
};

FullPageLoader.displayName = 'FullPageLoader';

export default FullPageLoader;
